import type { Patient } from "@louise/medical-history/basic-info/calculateBasicInfoCompletion";

export function calculateFamilyHistoryCompletion(
  patient: Patient | null | undefined,
) {
  const fh = (patient as any)?.familyHistory;

  // Step 1: Ethnicity answered
  const hasEthnicity =
    Array.isArray(fh?.ancestryHistory) && fh.ancestryHistory.length > 0;

  // Step 2: DNA test answered
  const hasDnaTest = fh?.hasDoneDNAAncestryReport != null;

  // Step 3: Adoption answered
  const hasAdoption = fh?.adoptionStatus != null;

  // If adopted or gamete donation, skip family questions
  const isAdopted =
    fh?.adoptionStatus === "adopted_or_dont_know_biological_parents" ||
    fh?.adoptionStatus === "from_gamete_donation";

  if (isAdopted) {
    // Only 3 steps required
    const total = 3;
    const completed =
      (hasEthnicity ? 1 : 0) + (hasDnaTest ? 1 : 0) + (hasAdoption ? 1 : 0);
    const percent = completed / total;
    const label = `${completed}/${total} answered`;
    return { percent, label, completed, total };
  }

  // Not adopted — full set of questions
  // Step 4: Family infertility answered
  const hasFamilyInfertility = fh?.hasRelativeFacingFertilityIssues != null;

  // Step 5: DES answered
  const hasDes = fh?.hasMotherTakenDESDuringPregnancy != null;

  // Step 6: Diseases (maternal + paternal counts as one step — both optional free text)
  // Count as complete if DES is answered (diseases are optional)
  const hasDiseases = hasDes;

  const total = 6;
  const completed =
    (hasEthnicity ? 1 : 0) +
    (hasDnaTest ? 1 : 0) +
    (hasAdoption ? 1 : 0) +
    (hasFamilyInfertility ? 1 : 0) +
    (hasDes ? 1 : 0) +
    (hasDiseases ? 1 : 0);
  const percent = completed / total;
  const label = `${completed}/${total} answered`;

  return { percent, label, completed, total };
}
